const sampleImages = {
  size: [
    { name: '8x10', src: require('./assets/images/sample/size/8x10.png') },
    { name: '9x9', src: require('./assets/images/sample/size/9x9.png') },
    { name: '10x8', src: require('./assets/images/sample/size/10x8.png') },
    { name: '11x14', src: require('./assets/images/sample/size/11x14.png') },
    { name: '12x12', src: require('./assets/images/sample/size/12x12.png') },
    { name: '14x11', src: require('./assets/images/sample/size/14x11.png') },
    { name: '16x20', src: require('./assets/images/sample/size/16x20.png') },
    { name: '20x16', src: require('./assets/images/sample/size/20x16.png') },
    { name: '20x20', src: require('./assets/images/sample/size/20x20.png') },
    { name: '20x30', src: require('./assets/images/sample/size/20x30.png') },
    { name: '24x24', src: require('./assets/images/sample/size/24x24.png') },
    { name: '30x20', src: require('./assets/images/sample/size/30x20.png') },
    { name: '30x30', src: require('./assets/images/sample/size/30x30.png') },
    { name: '30x40', src: require('./assets/images/sample/size/30x40.png') },
    { name: '40x30', src: require('./assets/images/sample/size/40x30.png') },
  ],
  attribute: [
    { name: 'satin', src: require('./assets/images/sample/attribute/satin.jpg') },
    { name: 'photo-grey', src: require('./assets/images/sample/attribute/photo-grey.jpg') },
    {
      name: 'off-white-textured',
      src: require('./assets/images/sample/attribute/off-white-textured.jpg'),
    },
    {
      name: 'off-white-acid-free',
      src: require('./assets/images/sample/attribute/off-white-acid-free.jpg'),
    },
    { name: 'no-mat', src: require('./assets/images/sample/attribute/no-mat.jpg') },
    {
      name: 'matted-5mm-foam-cello-bag',
      src: require('./assets/images/sample/attribute/matted-5mm-foam-cello-bag.png'),
    },
    {
      name: 'matted-3mm-foam-cello-bag',
      src: require('./assets/images/sample/attribute/matted-3mm-foam-cello-bag.jpeg'),
    },
    {
      name: 'matte-art-paper',
      src: require('./assets/images/sample/attribute/matte-art-paper.jpg'),
    },
    {
      name: 'hahnemuhle-ultra-smooth',
      src: require('./assets/images/sample/attribute/hahnemuhle-ultra-smooth.jpg'),
    },
    {
      name: 'hahnemuhle-photo-rag-308',
      src: require('./assets/images/sample/attribute/hahnemuhle-photo-rag-308.jpg'),
    },
    {
      name: 'hahnemuhle-metallic-pearl',
      src: require('./assets/images/sample/attribute/hahnemuhle-metallic-pearl.jpg'),
    },
    {
      name: 'hahnemuhle-bright-white',
      src: require('./assets/images/sample/attribute/hahnemuhle-bright-white.jpg'),
    },
    {
      name: 'bright-white-acid-free',
      src: require('./assets/images/sample/attribute/bright-white-acid-free.png'),
    },
    { name: 'bright-white', src: require('./assets/images/sample/attribute/bright-white.jpg') },
    { name: 'black', src: require('./assets/images/sample/attribute/black.jpg') },
  ],
}

const sampleItems = [
  {
    id: 14,
    name: 'MattedPrint (24x36)',
    cost: 0.18,
    quantity: 36,
    comment: 'occaecati et blanditiis culpa sed necessitatibus',
    options: {
      'Colour Space': 'adobeRGB',
      'Glass Type': 'Clear',
      'Paper Type': 'Hahnemuhle Photo Rag 308',
      'Print Size': '24x36',
    },
    images: [
      {
        quantity: 9,
        thumbnail_url: 'https://lorempixel.com/640/480/?21075',
      },
      {
        quantity: 4,
        thumbnail_url: 'https://lorempixel.com/640/480/?42434',
      },
      {
        quantity: 3,
        thumbnail_url: 'https://lorempixel.com/640/480/?16404',
      },
      {
        quantity: 10,
        thumbnail_url: 'https://lorempixel.com/640/480/?87335',
      },
      {
        quantity: 10,
        thumbnail_url: 'https://lorempixel.com/640/480/?59326',
      },
    ],
  },
  {
    id: 15,
    name: 'Wallpaper (20x30)',
    options: {
      'Colour Space': 'adobeRGB',
      'Glass Type': 'Reflection Control',
      'Paper Type': 'Hahnemuhle Museum Etching',
      'Print Size': '20x30',
    },
    images: [
      {
        quantity: 4,
        thumbnail_url: 'https://lorempixel.com/640/480/?79106',
      },
      {
        quantity: 4,
        thumbnail_url: 'https://lorempixel.com/640/480/?65275',
      },
      {
        quantity: 3,
        thumbnail_url: 'https://lorempixel.com/640/480/?22855',
      },
    ],
    cost: 1.08,
    quantity: 11,
    comment: 'debitis non distinctio cupiditate tenetur asperiores',
  },
]

const sampleItemProgress = {
  'id-14': [
    {
      item_id: 14,
      name: 'Printing',
      status: 3,
      current: false,
    },
    {
      item_id: 14,
      name: 'Matting',
      status: 1,
      current: true,
    },
  ],
  'id-15': [
    {
      item_id: 15,
      name: 'Printing',
      status: 1,
      current: true,
    },
  ],
}

export { sampleImages, sampleItems, sampleItemProgress }
